<div class="view-container">
    <div class="hero-section">
        <h1>Patreon Perks</h1>
        <p class="hero-subtitle">Unlock exclusive in-game content and features by supporting us on Patreon!</p>
    </div>

    <!-- Setup Progress Section - First Section -->
    @if (accountService.account.value) {
        <div class="setup-progress-section">
            <h2>Claim your perks</h2>
            <div class="progress-container">
                <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="setupProgress"></div>
                </div>
                <div class="progress-text">{{setupProgress}}% Complete</div>
            </div>
            
            <div class="checklist">
                <mat-card class="checklist-item" [class.completed]="isVRChatConnected">
                    <mat-card-content class="checklist-content-wrapper">
                        <div class="checklist-icon">
                            @if (vrchatCnnt) {
                                <div mat-card-avatar class="avatar-wrapper">
                                    <app-avatar [src]="vrchatCnnt.avatar" [alt]="vrchatCnnt.username"></app-avatar>
                                </div>
                            } @else {
                                <mat-icon>radio_button_unchecked</mat-icon>
                            }
                        </div>
                        <div class="checklist-content">
                            <h3>
                                @if (vrchatCnnt) {
                                    Connected VRChat: {{vrchatCnnt.username}}
                                } @else {
                                    Connected VRChat
                                }
                            </h3>
                            <p>
                                @if (vrchatCnnt) {
                                You have connected your VRChat account to your account.<br>
                                    If you have changed or renamed your VRChat account, you will need to disconnect and reconnect your account.
                                } @else {
                                    You have not connected your VRChat account to your account.
                                }
                            </p>
                        </div>
                        <div class="checklist-action">
                            @if (!vrchatCnnt) {
                                <button mat-flat-button  (click)="connectVRChat()">Connect</button>
                            } @else {
                                <button mat-button (click)="disconnectVRChat()">Disconnect</button>
                            }
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card class="checklist-item" [class.completed]="isPatreonConnected && !hasNoMembership" [class.failed]="hasNoMembership">
                    <mat-card-content class="checklist-content-wrapper">
                        <div class="checklist-icon">
                            @if (patreonCnnt) {
                                <div mat-card-avatar class="avatar-wrapper">
                                    <app-avatar [src]="patreonCnnt.avatar" [alt]="patreonCnnt.username"></app-avatar>
                                </div>
                            } @else if (hasNoMembership) {
                                <mat-icon>error</mat-icon>
                            } @else {
                                <mat-icon>radio_button_unchecked</mat-icon>
                            }
                        </div>
                        <div class="checklist-content">
                            <h3>
                                @if (patreonCnnt) {
                                    Connected Patreon: {{patreonCnnt.username}}
                                } @else {
                                    Connected Patreon
                                }
                            </h3>
                            <p>
                                @if (patreonCnnt) {
                                    You have connected your Patreon account to your account.
                                } @else {
                                    You have not connected your Patreon account to your account.
                                }
                            </p>
                            @if (patreonCnnt && patreonCnnt.subscriptionTier.id >= 0) {
                                <span class="tier-info" [style.color]="patreonCnnt.subscriptionTier.color" style="font-weight: 600;">
                                    {{patreonCnnt.subscriptionTier.name}}
                                </span>
                            }
                        </div>
                        <div class="checklist-action">
                            @if (!patreonCnnt) {
                                <div style="display: inline-flex; flex-direction: column; gap: 4px;">
                                    <button mat-flat-button  [disabled]="!pow && !powError" (click)="connectPatreon()">{{ pow ? 'Connect' : (powError ? 'Retry' : 'Preparing...') }}</button>
                                    @if (!pow && !powError) {
                                        <app-pow-progress />
                                    }
                                </div>
                            } @else {
                                <button mat-button (click)="disconnectPatreon()">Disconnect</button>
                            }
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card class="checklist-item" [class.completed]="arePerksActivated" [class.failed]="hasNoMembership">
                    <mat-card-content class="checklist-content-wrapper">
                        <div class="checklist-icon">
                            @if (arePerksActivated) {
                                <mat-icon>check_circle</mat-icon>
                            } @else if (hasNoMembership) {
                                <mat-icon>error</mat-icon>
                            } @else {
                                <mat-icon>radio_button_unchecked</mat-icon>
                            }
                        </div>
                        <div class="checklist-content">
                            @if (hasNoMembership) {
                                <h3>Perks Not Activated</h3>
                                <p>There are issues with your Patreon connection.</p>
                            } @else {
                                <h3>Perks Activated</h3>
                                <p>Your perks will be automatically activated once both accounts are connected</p>
                            }

                            @if (arePerksActivated) {
                                <span class="activated-status">✅ Perks are now active in VRChat!</span>
                            } @else if (hasNoMembership) {
                                <span class="error-status">❌ No active Patreon membership found</span>
                                <div class="troubleshooting-content">
                                    @if (patreonCnnt?.subscriptionTier?.id == -1) {
                                        <p>Your account does not have an active membership. Please note that free memberships are not eligible for perks.</p>
                                        <ul>
                                            <li>Go to the <a href="https://www.patreon.com/vr_jar/membership" target="_blank">Patreon Membership Page</a> and make sure you see your Membership details.</li>
                                            <li>If you are logged in with the wrong account, log out on patreon.com and log in again with the correct account.</li>
                                            <li>Then, remove your connection above and connect again.</li>
                                        </ul>
                                    } @else if (patreonCnnt?.subscriptionTier?.id == -2) {
                                        <p>Your last payment was declined. Your membership is currently inactive.</p>
                                        <p><a href="https://support.patreon.com/hc/en-us/articles/203191209-Why-was-my-payment-declined-" target="_blank">Learn More</a></p>
                                    }
                                    <p>If you still do not see the correct membership status after following the steps above, please contact us via <a href="https://discord.gg/cult-of-jar" target="_blank">Discord</a> or <a href="https://www.patreon.com/messages" target="_blank">Patreon</a>.</p>
                                </div>
                            }

                            @if (arePerksActivated) {
                                <br>
                                <h3>Did your perks suddenly stop working?</h3>
                                <button mat-button (click)="troubleshootPerks()">Click here to troubleshoot</button>
                            }
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>


        </div>
    } @else {
        <!-- Guest User Section -->
        <div class="guest-section">
            <h2>Get Started</h2>
            <div class="guest-options">
                <mat-card class="option-card">
                    <div class="option-icon">
                        <mat-icon>account_circle</mat-icon>
                    </div>
                    <mat-card-content>
                        <h3>Create an Account</h3>
                        <p>For the best experience, create an account using Discord. This allows you to easily manage your Patreon perks and track your progress.</p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-flat-button  routerLink="/login">Login with Discord</button>
                    </mat-card-actions>
                </mat-card>
                
                <mat-card class="option-card">
                    <div class="option-icon">
                        <mat-icon>person_add</mat-icon>
                    </div>
                    <mat-card-content>
                        <h3>Guest Submission</h3>
                        <p>Don't want to create an account? You can still unlock your perks using our guest submission system. Just provide your VRChat username and Patreon details.</p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-flat-button (click)="guestSubmission()">Submit as Guest</button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    }

    <div class="perks-section">
        <h2>What you get</h2>
        <div class="perks-carousel-container">
            <!-- Desktop buttons (positioned on sides) -->
            <button 
                mat-icon-button 
                class="carousel-nav-button carousel-nav-prev carousel-nav-desktop" 
                (click)="previousPerk()"
                aria-label="Previous perk">
                <mat-icon>chevron_left</mat-icon>
            </button>
            
            <div class="perks-carousel-wrapper">
                <div class="perks-carousel" 
                     [style.transform]="getCarouselTransform()" 
                     [class.transitioning]="isTransitioning"
                     (touchstart)="onManualInteraction('touch')"
                     (mousedown)="onManualInteraction('mouse')">
                    @for (perk of getInfinitePerks(); track $index) {
                        <div class="perk-card-container">
                            <mat-card class="perk-card">
                                
                                <img class="perk-image" [src]="perk.imageUrl" [alt]="perk.name + ' perk'" />
                                <mat-card-content class="perk-content">
                                    <h3>{{perk.name}}</h3>
                                    <p>{{perk.description}}</p>
                                    <ul class="perk-features">
                                        @for (feature of perk.features; track feature) {
                                            <li>{{feature}}</li>
                                        }
                                    </ul>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    }
                </div>
            </div>
            
            <button 
                mat-icon-button 
                class="carousel-nav-button carousel-nav-next carousel-nav-desktop" 
                (click)="nextPerk()"
                aria-label="Next perk"
                [class.auto-rotate]="isAutoRotateEnabled"
                >
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
        
        <!-- Mobile buttons (positioned below carousel) -->
        <div class="carousel-nav-mobile">
            <button 
                mat-flat-button 
                class="carousel-nav-button carousel-nav-prev carousel-nav-mobile-btn" 
                (click)="previousPerk()"
                aria-label="Previous perk">
                <mat-icon>chevron_left</mat-icon>
                Previous
            </button>
            
            <button 
                mat-flat-button 
                class="carousel-nav-button carousel-nav-next carousel-nav-mobile-btn" 
                (click)="nextPerk()"
                aria-label="Next perk"
                [class.auto-rotate]="isAutoRotateEnabled"
                >
                Next
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
        
        <!-- Carousel indicators -->
        <div class="carousel-indicators">
            @for (perk of perks; track perk.id; let i = $index) {
                <button 
                    class="indicator" 
                    [class.active]="i === getActualPerkIndex()"
                    (click)="goToPerk(i)"
                    [attr.aria-label]="'Go to ' + perk.name">
                </button>
            }
        </div>
    </div>
    <!-- CTA Section with Tiers - Third Section -->
    <div class="cta-section">
        <div class="cta-content">
            <div class="cta-text">
                <h2>Missing Out on Exclusive Perks?</h2>
                <p class="cta-description">Jar creates VRChat worlds full-time, powered by supporters like you. Join her Patreon from just <span class="price-highlight">$1/month</span> to get amazing rewards!</p>
                <div class="cta-benefits">
                    <div class="benefit-item">
                        <mat-icon>star</mat-icon>
                        <span>Unlock unique cosmetic rewards in Jar's games</span>
                    </div>
                    <div class="benefit-item">
                        <mat-icon>attribution</mat-icon> <span>See your name on the Patron Credits board</span>
                    </div>
                    <div class="benefit-item">
                        <mat-icon>savings</mat-icon> <span>Directly fund the creation of new VRChat worlds</span>
                    </div>
                </div>
            </div>
            <div class="cta-action">
                <a mat-flat-button class="cta-button" href="https://www.patreon.com/vr_jar" target="_blank">
                    <mat-icon>favorite</mat-icon>
                    Support Jar on Patreon
                </a>
            </div>
        </div>
    </div>
</div>



<!-- Floating Action Button -->
<button 
    mat-fab 
     
    class="floating-scroll-button"
    [class.visible]="showFloatingButton"
    [class.hidden]="!showFloatingButton"
    (click)="scrollToPerks()"
    aria-label="Scroll to Get your perks section">
    <mat-icon>keyboard_arrow_down</mat-icon>
</button>

